<template>
    <div class="pay_tips" >
        <div class="pay_tips_bg"></div>
        <div class="pay_tips_content">
            <div class="pay_body">
                <div class="purse-header" >
                    <div class="header-left">
                        <img  @dragstart.prevent  src="../assets/touxiang.png" alt="">
                        <span>{{userInfo.nickname}}</span>
                    </div>
                    <p v-if='userInfo.vip'>会员截止时间：{{userInfo.vipEndDate}}</p>
                    <p v-else class="balance"><span>余额：</span><span>{{userMoney}} 看币</span></p>
                    <!-- <p >当前账号未开通会员</p> -->
                </div>
                <div class="purse-tempList">
                    <div
                    :class="[ (index + 1) % 2 == 0 ? 'item-noMargin' : '',(index == purActive) ? 'vtemp-item vitem-act' : '', 'vtemp-item',]"
                    @click="actPrice(index)" v-for="(item, index) in payList" :key="item.id">
                        <p>￥{{ item.price }}元</p>
                        <p v-if="item.cueWords">{{ item.cueWords }}</p>
                        <span v-if="item.label" class="btn">{{item.label}}</span>
                        <span v-if="item.corner" class="tag">{{ item.corner }}</span>
                    </div>
                </div>
            </div>
            <div class="purse-btn cursorPointer" @click="$emit('modelPay',{index:purActive})">
                立即充值
            </div>
            <div class="app-header__vip-close" @click="$emit('closePayModel')">
                <img  @dragstart.prevent  src="../assets/icon_pay_guanbi.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import { getUserInfo } from '../utils/utils'
    export default {
        name: 'payModel',
        props: {
            payList:{
                type: Array,
                required: true,
            },
            userMoney:{
                type:Number,
                required: true,
            },
        },
        data () {
            return {
                userInfo:[],
                purActive:0
            }
        },
        mounted(){
            this.userInfo = getUserInfo()
        },
        methods: {
            actPrice(e){
                this.purActive = e
            },
        }
    }
</script>
<style  scoped lang="scss">
    .pay_tips{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;

    .pay_tips_bg{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
    }
    .pay_tips_content{
        width: 600px;
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        
border-radius: 10px;
    }
    .app-header__vip-close {
        position: absolute;
        bottom: -60px;
        left: 285px;
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
    .app-header__vip-close img {
        width: 100%;
        height: 100%;
    }
    .app-header__vip-header {
        height: 140px;
        padding: 0 32px;
        background: #FFF4D9;
        display: flex;
        align-items: center;
    }

    .pay_body{
        padding: 20px;
    }

  .purse-tempList {
    // background-color: lawngreen;
    display: flex;
    flex-wrap: wrap;
    max-height: 303px;
    overflow: auto;
    .vtemp-item {
      width: 48%;
      border-radius: 10px;
      padding: 14px 20px 19px;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      background: #FFFFFF;
      border: 2px solid #E6E6E6;
      position: relative;
      margin-top: 20px;
      margin-right: 20px;
        p,div{
            margin-bottom: 10px;
        }
      p:nth-child(1) {
        font-size: 18px;
        
        color: #CB2945;
        line-height: 25px;
      }

      p:nth-child(2) {
        font-size: 14px;
        font-weight: 400;font-weight: lighter;
        color: #CB2945;
        line-height: 20px;
      }

      .btn{
        background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
        border-radius: 19px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        font-weight: 400;font-weight: lighter;
        color: #FFFFFF;
        padding: 3px 17px;
      }

      .tag{
        padding: 5px 15px 5px 23px;
        box-sizing: border-box;
        background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
        border-radius: 100px 0px 0px 100px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 20px;
        position: absolute;
        top: 10px;
        right: 0;
      }
    }

    .vitem-act {
      background: rgba(203, 41, 69, 0.06);
      border: 2px solid #CB2945;
    }
    .item-noMargin {
      margin-right: 0;
    }
    
  }
.purse-btn {
    width: 100%;
    height: 72px;
    background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
    font-size: 24px;
    color: #FFFFFF;
    line-height: 32px;
    position: relative;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
    .purse-header {
        height: 90px;
        background: rgba(203, 41, 69, 0.06);
        border-radius: 10px;
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .header-left {
            display: flex;
            align-items: center;
            height: 100%;
            font-size: 18px;
            color: #333333;
            line-height: 24px;
            img {
                width: 56px;
                height: 56px;
                background-color: #fff;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
    }
}
</style>
